export default {
  name: 'AnnotationAlertIcon',
  props: {
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#DB333B'
    }
  }
};